import { createContext, useContext, useState } from 'react';

const GlobalContext = createContext(null);

const GlobalProvider = ({ children }) => {
  const [pendingChanges, setPendingChanges] = useState({});

  const hasPendingChanges =
    Object.values(pendingChanges).filter(Boolean).length > 0;

  return (
    <GlobalContext.Provider
      value={{
        pendingChanges,
        setPendingChanges,
        hasPendingChanges,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobalContext = () => {
  const context = useContext(GlobalContext);
  if (context === undefined) {
    throw new Error('useGlobalContext must be used within a GlobalProvider');
  }
  return context;
};

export default GlobalProvider;
